import { Box } from '@chakra-ui/react';

interface AssignmentBuilderFormContainerProps {
  headerComponent: React.ReactNode;
  formComponent: React.ReactNode;
  bottomAddonComponent?: React.ReactNode;
  heightOffset?: number;
}

export default function AssignmentBuilderFormContainer({
  headerComponent,
  formComponent,
  bottomAddonComponent,
  heightOffset = 250,
}: AssignmentBuilderFormContainerProps) {
  return (
    <Box>
      <Box borderBottom="1px solid" borderBottomColor="neutral.100" padding={6}>
        {headerComponent}
      </Box>

      <Box padding={6} overflowY="auto" height={`calc(100vh - ${heightOffset}px)`} flex={1}>
        {formComponent}
      </Box>

      {bottomAddonComponent}
    </Box>
  );
}
